import { GET_JOB_PHASES } from '../../store/jobPhases/getters/getterTypes';

export default {
  computed: {
    sitePhases() {
      return this.$store.getters[GET_JOB_PHASES] || [];
    },
    defaultPhaseId() {
      const phases = this.sitePhases;
      return (phases.find((p) => p.isDefault) || phases[0])?._id ?? null;
    },
    activeReportSections() {
      const phaseId = this.$store.state.ReportsModule.selectedPhaseId;
      if (!phaseId) return null;
      const phase = this.sitePhases.find((p) => p._id === phaseId);
      if (!phase || !phase.reportSections || !phase.reportSections.length)
        return null;
      return phase.reportSections;
    },
  },
  methods: {
    isSectionVisible(key) {
      return (
        !this.activeReportSections || this.activeReportSections.includes(key)
      );
    },

    isTaskVisibleForPhase(task) {
      const phaseId = this.$store.state.ReportsModule.selectedPhaseId;
      if (!phaseId) return true;
      // Resolve the task's phase the same way the backend does: an unassigned
      // task (no jobPhaseId) is treated as belonging to the default phase.
      const taskPhaseId =
        task.jobPhaseId && task.jobPhaseId !== ''
          ? task.jobPhaseId
          : this.defaultPhaseId;
      return taskPhaseId === phaseId
        ? this.isSectionVisible('inspectionTasks')
        : this.isSectionVisible('additionalTasks');
    },
  },
};
